<template>
  <div class="main-wrap">
    <div class="container">
      <div class="top" v-if="isPC">
        <div></div>
        <div class="top_btn">
          <div class="btn1" @click="toBack">
            <img src="../assets/images/home1.png" alt="">
            <span>返回主页</span>
          </div>
          <div class="btn2" @click="toBack1">
            <img src="../assets/images/search1.png" alt="">
            <span>继续查询</span>
          </div>
        </div>
      </div>
      <div class="top1" v-if="!isPC">
        <div class="top_btn">
          <div class="btn1" @click="toBack">
            <img src="../assets/images/home1.png" alt="">
            <span>返回主页</span>
          </div>
          <div class="btn2" @click="toBack1">
            <img src="../assets/images/search1.png" alt="">
            <span>继续查询</span>
          </div>
        </div>
      </div>
      <div class="new-wrap">
        <div class="info-wrap zs-main zhengshu1" v-if="isPC">
          <div class="table_wrap">
            <div class="title-wrap">
              <span>{{ certificateData.type_parent_name }}查询结果报告</span>
              <span>QUERY RESULT REPORT</span>
            </div>
          </div>
          <table border="0" class="table_1" v-if="certificateData">
            <tr>
              <th colspan="4">
                <img src="../assets/images/dian1.png" alt="">
                <div>企业基本信息</div>
                <img src="../assets/images/dian2.png" alt=""></th>
            </tr>
            <tr>
              <td>单位名称</td>
              <td colspan="3">{{ certificateData.name }}</td>
            </tr>
            <tr>
              <td>法定代表人</td>
              <td>{{ certificateData.is_daoqi == 1?'***':certificateData.daibiao }}</td>
              <td>注册资金</td>
              <td>{{ certificateData.is_daoqi == 1 ? '***' : certificateData.money }}</td>
            </tr>
            <tr>
              <td>信用代码</td>
              <td>{{ certificateData.is_daoqi == 1 ? '***' : certificateData.code }}</td>
              <td>企业类型</td>
              <td>{{ certificateData.is_daoqi == 1 ? '***' : certificateData.hangye }}</td>
            </tr>
            <tr>
              <td>注册地址</td>
              <td colspan="3">{{ certificateData.is_daoqi == 1 ? '***' : certificateData.address }}</td>
            </tr>
          </table>
          <div class="tc"></div>
          <table border="0" class="table_2">
            <tr>
              <th colspan="4">
                <img src="../assets/images/dian1.png" alt="">
                <div>证书信息</div>
                <img src="../assets/images/dian2.png" alt="">
              </th>
            </tr>
            <tr>
              <td>证书类型</td>
              <td colspan="3">{{ certificateData.is_daoqi == 1 ? '***' : certificateData.type_parent_name }}</td>
            </tr>
            <tr>
              <td>证书名称</td>
              <td colspan="3">{{ certificateData.is_daoqi == 1 ? '***' : certificateData.zs_name }}</td>
            </tr>
            <tr>
              <td>会员编号</td>
              <td style="border-bottom-right-radius: 12px">
                {{ certificateData.is_daoqi == 1 ? '***' : certificateData.number }}
              </td>
              <td>会员有效期</td>
              <td>{{ certificateData.is_daoqi == 1?'***':formattedDate(certificateData.end_time) }}</td>
            </tr>
            <tr>
              <td>发证单位意见</td>
              <td colspan="3">
                <div style="padding: 12px 10px 12px 0">
                  {{ certificateData.is_daoqi == 1 ? '***' : certificateData.yijian }}
                </div>
              </td>
            </tr>
            <tr>
              <td>单位经营范围</td>
              <td colspan="3">
                <div style="padding: 12px 10px 12px 0">
                  {{ certificateData.is_daoqi == 1 ? '***' : certificateData.fanwei }}
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="info-wrap zs-main zhengshu1" v-if="!isPC">
          <div class="table_wrap">
            <div class="title-wrap">
              <span>{{ certificateData.type_parent_name }}查询结果报告</span>
              <span>QUERY RESULT REPORT</span>
            </div>
          </div>
          <table border="0" class="table_1">
            <tr>
              <th colspan="2">
                <img src="../assets/images/dian1.png" alt="">
                <div>企业基本信息</div>
                <img src="../assets/images/dian2.png" alt="">
              </th>
            </tr>
            <tr>
              <td>单位名称</td>
              <td>{{ certificateData.name }}</td>
            </tr>
            <tr>
              <td>法定代表人</td>
              <td>{{ certificateData.daibiao }}</td>
            </tr>
            <tr>
              <td>注册资金</td>
              <td>{{ certificateData.is_daoqi == 1 ? '***' : certificateData.money }}</td>
            </tr>
            <tr>
              <td>信用代码</td>
              <td>{{ certificateData.is_daoqi == 1 ? '***' : certificateData.code }}</td>
            </tr>
            <tr>
              <td>企业类型</td>
              <td>{{ certificateData.is_daoqi == 1 ? '***' : certificateData.hangye }}</td>
            </tr>
            <tr>
              <td>注册地址</td>
              <td>{{ certificateData.is_daoqi == 1 ? '***' : certificateData.address }}</td>
            </tr>
          </table>
          <table border="0" class="table_2" style="margin-top: 20px">
            <tr>
              <th colspan="2">
                <img src="../assets/images/dian1.png" alt="">
                <div>证书信息</div>
                <img src="../assets/images/dian2.png" alt="">
              </th>
            </tr>
            <tr>
              <td>证书类型</td>
              <td class="td2" v-if="certificateData.type_parent_name">
                {{ certificateData.is_daoqi == 1 ? '***' : certificateData.type_parent_name }}
              </td>
            </tr>
            <tr>
              <td>证书名称</td>
              <td class="td2">{{ certificateData.is_daoqi == 1 ? '***' : certificateData.zs_name }}</td>
            </tr>
            <tr>
              <td>会员编号</td>
              <td class="pr14">{{ certificateData.is_daoqi == 1 ? '***' : certificateData.number }}</td>
            </tr>
            <tr>
              <td>会员有效期</td>
              <td>{{ certificateData.is_daoqi == 1 ? '***' : formattedDate(certificateData.end_time) }}</td>
            </tr>
            <tr>
              <td>发证单位意见</td>
              <td>
                <div style="padding: 12px 10px 12px 0;margin-left: -6px">
                  {{ certificateData.is_daoqi == 1 ? '***' : certificateData.yijian }}
                </div>
              </td>
            </tr>
            <tr>
              <td>单位经营范围</td>
              <td>
                <div style="padding: 12px 10px 12px 0;margin-left: -6px">
                  {{ certificateData.is_daoqi == 1 ? '***' : certificateData.fanwei }}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  search_user,
} from "@/api/index";
export default {
  name: 'CertificateQueryResultPage',
  data() {
    return {
      certificateData: {},
      isPC: false,
      currentTime: '',
    };
  },
  mounted() {
    if (this.isMobile()) {
      this.isPC = false
    } else {
      this.isPC = true
    }
    let info = JSON.parse(sessionStorage.getItem('companyInfo'))

    let ajax = {
      type: info.type_id,
      name: info.name,
      code: info.code,
      number: info.number,
    }
    this.getDetail(ajax)
    this.getCurrentTime()
  },
  methods: {
    getCurrentTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0') // 月份从0开始，需+1
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')

      this.currentTime = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`
    },
    formattedDate(data) {
      if (typeof data === 'string' && /^\d{4}年\d{1,2}月\d{1,2}日$/.test(data)) {
        return data;
      }
      const date = new Date(data);

      // 检查是否是有效日期
      if (isNaN(date.getTime())) {
        console.warn('无效的日期格式:', data);
        return data || ''; // 或返回原始值/空字符串
      }

      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}年${month}月${day}日`;
    },
    getDetail(ajax) {
      search_user(ajax).then(res => {
        if (res.code == 1) {
          this.certificateData = res.data
        }
      })
    },
    isMobile() {
      const ua = navigator.userAgent;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    },
    toBack() {
      sessionStorage.removeItem('companyInfo')
      this.$router.push({
        path: '/',
        query: {}
      })
    },
    toBack1() {
      sessionStorage.removeItem('companyInfo')
      this.$router.go(-1)
    }
  }
};
</script>

<style scoped lang="scss">
.main-wrap {
  background: url('../assets/images/result-bg.png') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  color: white;
  font-family: Arial, sans-serif;
  min-height: 100vh;
  width: 100%;
}

.container {
  padding: 30px 50px 30px 50px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo {
    cursor: pointer;
  }
}

.top1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  position: relative;

  img {
    width: 100%;
  }
}

.top_btn {
  display: flex;
  align-items: center;
  color: #333333;
}

.top_btn .btn1 {
  margin-left: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.top_btn .btn1 img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.top_btn .btn2 {
  margin-left: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.top_btn .btn2 img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.title-wrap {
  position: relative;
  width: 100%;
}

.title-wrap span:nth-child(1) {
  font-family: PingFang SC;
  font-weight: 800;
  font-size: 42px;
  color: #333;
  letter-spacing: 3px;
}

.title-wrap span:nth-child(2) {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 30px;
  color: #333;
  opacity: 0.1;
  position: absolute;
  top: 18px;
  left: calc((100% - 400px) / 2);
  text-align: center;
}

.new-wrap {
  width: 1296px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
}

.info-wrap {
  text-align: center;
  border-radius: 30px;
  padding: 60px 50px;
}

.zs-main.zhengshu1 table {
  border-collapse: collapse;
  //border: 1px solid #3661b8;
  width: 100%;
}

.zs-main.zhengshu1 th {
  font-size: 24px;
  color: #fff;
  font-weight: bold;
  width: 1024px;
  height: 64px;
  background: linear-gradient(to right, #1d4ed8, #3b82f6);
  border-radius: 12px 12px 0px 0px;

  img {
    width: 75px;
    height: 20px;
  }

  div {
    display: inline-block;
    margin: 0 60px;
  }
}

.table_wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
}

.table_title {
  display: flex;
  align-items: center;
}

.table_title span {
  text-align: center;
  font-size: 38px;
  color: #fff;
  font-family: "宋体", SimSun, "微软雅黑", "Microsoft YaHei", sans-serif;
  font-weight: bold;
  margin-left: 5px;
}

.zs-main.zhengshu1 td {
  width: 25%;
}

.zs-main.zhengshu1 table td {
  border: 1px solid #0077ff;
}

.zs-main.zhengshu1 .table_1 td:first-child, .zs-main.zhengshu1 .table_1 td:nth-child(3n) {
  height: 60px;
  font-size: 20px;
  color: #333;
  font-family: "宋体", SimSun, "微软雅黑", "Microsoft YaHei", sans-serif;
  font-weight: bold;
  background: #f0f7ff;;
}

.zs-main.zhengshu1 .table_1 td:nth-child(2n), .zs-main.zhengshu1 .table_1 td:nth-child(4n) {
  height: 60px;
  font-size: 18px;
  color: #333;
  text-align: left;
  padding-left: 20px;
  background: #f0f7ff;;
}

.zs-main.zhengshu1 .table_2 td:first-child, .zs-main.zhengshu1 .table_2 td:nth-child(3n) {
  height: 60px;
  font-size: 20px;
  color: #333;
  font-family: "宋体", SimSun, "微软雅黑", "Microsoft YaHei", sans-serif;
  font-weight: bold;
  background: #f0f7ff;;
}

.zs-main.zhengshu1 .table_2 td:nth-child(2n), .zs-main.zhengshu1 .table_2 td:nth-child(4n) {
  height: 60px;
  font-size: 18px;
  color: #333;
  text-align: left;
  padding-left: 20px;
  background: #f0f7ff;;
}

.zs-main.zhengshu1 .table_3 .tit td {
  height: 60px;
  font-size: 20px;
  color: #333;
  font-family: "宋体", SimSun, "微软雅黑", "Microsoft YaHei", sans-serif;
  font-weight: bold;
  text-align: center;
}

.zs-main.zhengshu1 .table_3 .tit1 {
  display: flex;
  background: #f0f7ff;;
  border-radius: 0 0 12px 12px;
}

.zs-main.zhengshu1 .table_3 .tit2 {
  height: 100px;
  display: flex;
  align-items: center;
  background: #f0f7ff;;
  border-radius: 0 0 12px 12px;
  font-size: 20px;
}

.zs-main.zhengshu1 .table_3 .tit1-item {
  display: flex;
  flex-direction: column;
  width: 25%;
}

.zs-main.zhengshu1 .table_3 .tit1 td {
  height: 60px;
  line-height: 60px;
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.zs-main.zhengshu1 .table_3 td {
  width: 100% !important;
}

.table_3 th {
  color: #fff !important;
}

.tc {
  width: 100%;
  height: 20px;
}

.table_2 {
  border-collapse: collapse;
  width: 100%;
}

.table_3 {
  margin-top: 20px;
  border-collapse: collapse;
  width: 100%;
}

@media only screen and (max-width: 600px) {
  .container {
    width: 100%;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
  }

  .info-wrap {
    text-align: center;
    margin: 0px 10px 0 10px;
    border-radius: 15px;
    padding: 30px 10px;
  }

  .title-wrap {
    position: relative;
    width: 100%;
  }
  .title-wrap span:nth-child(1) {
    font-family: PingFang SC;
    font-weight: 800;
    font-size: 20px;
    color: #333;
  }

  .title-wrap span:nth-child(2) {
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #333;
    opacity: 0.1;
    position: absolute;
    top: 10px;
    left: calc((100% - 188px) / 2);
    text-align: center;
  }
  .new-wrap {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
  }
  .table_wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }
  .zs-main.zhengshu1 td {
    width: 0%;
  }

  .table_title {
    display: flex;
    align-items: center;
  }
  .table_title span {
    text-align: center;
    font-size: 30px;
    color: #333;
    font-family: "宋体", SimSun, "微软雅黑", "Microsoft YaHei", sans-serif;
    font-weight: bold;
    margin-left: 5px;
  }
  .table_title img {
    width: 62px;
  }
  .zs-main.zhengshu1 th {
    height: 50px;
    font-size: 18px;
    color: #333;
    font-weight: bold;
  }


  .top_btn {
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: -10px;
  }

  .top_btn .btn1 {
    margin-left: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .top_btn .btn1 img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  .top_btn .btn2 {
    margin-left: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .top_btn .btn2 img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  .zs-main.zhengshu1 .table_1 td:first-child, .zs-main.zhengshu1 .table_1 td:nth-child(3n) {
    height: 50px;
    font-size: 16px;
    color: #333;
    font-family: "宋体", SimSun, "微软雅黑", "Microsoft YaHei", sans-serif;
    font-weight: bold;
    background: #f0f7ff;;
  }
  .zs-main.zhengshu1 .table_1 td:nth-child(2n), .zs-main.zhengshu1 .table_1 td:nth-child(4n) {
    height: 50px;
    font-size: 14px;
    color: #333;
    text-align: left;
    padding-left: 20px;
    background: #f0f7ff;;
  }
  .zs-main.zhengshu1 .table_2 td:first-child, .zs-main.zhengshu1 .table_2 td:nth-child(3n) {
    height: 50px;
    font-size: 16px;
    color: #333;
    font-family: "宋体", SimSun, "微软雅黑", "Microsoft YaHei", sans-serif;
    font-weight: bold;
    background: #f0f7ff;;
  }
  .zs-main.zhengshu1 .table_2 td:nth-child(2n), .zs-main.zhengshu1 .table_2 td:nth-child(4n) {
    height: 50px;
    font-size: 14px;
    color: #333;
    text-align: left;
    padding-left: 20px;
    background: #f0f7ff;;
  }
  .table_2 {
    margin-top: 1px;
  }
  .zs-main.zhengshu1 .table_3 .tit1 {
    display: flex;
    flex-direction: column;
    background: #f0f7ff;;
    border-radius: 0 0 12px 12px;
  }

  .zs-main.zhengshu1 .table_3 .tit1-item {
    display: flex;
    flex-direction: column;
    width: 25%;
  }
  .zs-main.zhengshu1 .table_3 .tit11 td {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    color: #333;
    text-align: center;
    width: 50% !important;
    background: #f0f7ff;;
  }
  .zs-main.zhengshu1 th div {
    margin: 0 10px;
    color: #ffffff;
  }
}

.pr14 {
  padding-right: 14px;
}

.td2 {
  //width: max-content !important;
  //min-width: 133.5px;
  //display: inline-block;
}
</style>
